module.exports = __webpack_public_path__ + "img/ic-sort.642f3ec9.svg";